import { useEffect } from "react";
import { PluginEventMap, subscribeEvent } from "../utils/pluginEvents";

export const usePluginEvent = <K extends keyof PluginEventMap>(
    type: K,
    callback: (detail: PluginEventMap[K]) => void
): void => {
    useEffect(() => {
        const unsubscribe = subscribeEvent(type, callback);
        return () => unsubscribe();
    }, [type, callback]);
}
